import { apiSlice } from "./baseQuery";
import { WaitListRequest, WaitListResponse } from "./declarations";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    waitList: builder.mutation<WaitListResponse, WaitListRequest>({
      query: (credentials) => ({
        url: "waitlist",
        method: "POST",
        body: { ...credentials },
      }),
    }),
  }),
});

export const { useWaitListMutation } = authApiSlice;
